import React from "react";
import { TCustomer } from "../../../../types/Types";
import InfoRow from "./InfoRow";
import {
  UserIcon,
  PhoneIcon,
  MapPinIcon,
  AcademicCapIcon,
  CalendarIcon,
} from "@heroicons/react/24/outline";
import { EnvelopeIcon } from "@heroicons/react/20/solid";
import moment from "moment";

interface InfoCardProps {
  customer: TCustomer;
}

const InfoCard = ({ customer }: InfoCardProps) => {
  return (
    <div className="bg-white rounded-3xl border border-gray-100 shadow-sm p-6">
      <h2 className="text-lg font-bold text-gray-800 mb-6 flex items-center gap-2">
        <UserIcon className="w-5 h-5 text-primary" />
        Contact Information
      </h2>
      <div className="space-y-6">
        <InfoRow
          icon={<EnvelopeIcon className="w-5 h-5" />}
          label="Email"
          value={customer.email ?? ""}
        />
        <InfoRow
          icon={<PhoneIcon className="w-5 h-5" />}
          label="Phone Number"
          value={customer.phNo ?? ""}
        />
        <InfoRow
          icon={<CalendarIcon className="w-5 h-5" />}
          label="Date of Birth"
          value={moment(customer.dob).format("DD MMMM, YYYY")}
        />
        <InfoRow
          icon={<MapPinIcon className="w-5 h-5" />}
          label="Location"
          value={customer.location || "Not specified"}
        />
        <InfoRow
          icon={<AcademicCapIcon className="w-5 h-5" />}
          label="Education"
          value={customer.education}
        />
      </div>
    </div>
  );
};

export default InfoCard;
